export type PeriodType = 'monthly' | 'yearly';

export type PeriodValue = {
  month: string;
  year: string;
  period: PeriodType;
};

export const PERIOD_OPTIONS: PeriodType[] = ['monthly', 'yearly'];

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const getDateRangeFromPeriod = (periodValue: PeriodValue): { from: string; to: string } => {
  const year = parseInt(periodValue.year, 10);

  if (periodValue.period === 'yearly') {
    const from = new Date(year, 0, 1, 0, 0, 0, 0);
    const to = new Date(year, 11, 31, 23, 59, 59, 999);
    return {
      from: from.toISOString(),
      to: to.toISOString(),
    };
  }

  const monthIndex = MONTHS.indexOf(periodValue.month);
  const from = new Date(year, monthIndex, 1, 0, 0, 0, 0);
  const to = new Date(year, monthIndex + 1, 0, 23, 59, 59, 999);

  return {
    from: from.toISOString(),
    to: to.toISOString(),
  };
};
